import React, { useMemo, useState }from "react";
import { Icon } from 'dlweb-components';
import { connect } from "react-redux";
import { Select, Spin, Button, Popover, Radio, Space } from "antd";
import styled from "styled-components";
import _, { set } from 'lodash';

const UserPicker = ({value = [], onChange, blacklist, workingFolder, includeGroups, restrictUsers, multiSelect = true}) => {

  const fetchRef = React.useRef(0);

  const [users, setUsers] = useState([]);
  const [selectOpen, setSelectOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({label: 'Username', value: 'ID'});

  const onOpenChange = (isOpen) => {
    setPopoverOpen(isOpen);
  }
  
  const onSelect = (e) => {
    const { label, value } = e.target;
    setFilter({label, value});
  }

  const debounceFetcher = useMemo(() => {
    const loadUsers = (value) => {

      if(value.length === 0) {
        setUsers([]);
        return;
      }

      if(value.length < 2) return;

      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setUsers([]);
			setLoading(true);

      const searchFilter = {
        userSqlFilter:  { [filter.value]: value, __BracketWildcards: true},
      }

      const processResponse = (res) => {
        if (fetchId !== fetchRef.current) return;
      
        const userList = _.filter(res.data.data, o => !_.includes(blacklist, o.id)).map((user) => ({
          label: (
            <div style={{ display: 'inline-block' }}>
              <Icon
                type={user.type ? user.type.toLowerCase() === 'user' ? 'user' : 'users' : 'user'}
                size="lg"
                faStyle="fas"
                style={{
                  marginRight: '10px',
                  color: 'var(--primary-light)',
                }}
              />
              <span style={{ fontWeight: 600, marginRight: '5px' }}>
                {user.name ?? user.id}
              </span>
            </div>
          ),
          value: user.id,
        }));

        setUsers(userList);
        setLoading(false);
      };

      if(includeGroups) {
			  axios.post('/api/wt/groupman/search', { query: value, column: filter.value, folderId: workingFolder, restrictUsers: restrictUsers }).then(processResponse)
      } 
      else {
        axios.post('/api/wt/userman/search', searchFilter).then(processResponse)
      }
    };

    return _.debounce(loadUsers, 500);
  }, [filter, blacklist, includeGroups, workingFolder]);

  const content = (
    <Content>
      <Radio.Group
        value={filter.value}
        onChange={onSelect}
      >
        <Space direction="vertical">
          <Radio label="Username" value="ID">Username</Radio>
          <Radio label="Display Name" value="DisplayName">Display Name</Radio>
          <Radio label="Department" value="Department">Department</Radio>
          <Radio label="Job Title" value="Title">Job Title</Radio>
          <Radio label="Manager" value="Supervisor">Manager</Radio>
        </Space>
      </Radio.Group>
    </Content>
  );

  const onUserSelect = () => {
    // if we don't do this ant will not format the user tag correctly
    setTimeout(() => setUsers([]))
  }

  const handleDropdownVisibleChange = (isOpen) => {
    setSelectOpen(isOpen);
  };

  const handleSelectChange = (selectedUsers) => {
    onChange?.(selectedUsers);
  }

  return (
    <Container>
      <Select
          showSearch
          value={value}
          mode={multiSelect ? "multiple" : "default"}
          options={users}
          open={selectOpen}
          loading={loading}
          filterOption={false}
          onSelect={onUserSelect}
          onChange={handleSelectChange}
          onDropdownVisibleChange={handleDropdownVisibleChange}
          placeholder={`Search on ${filter.label}`}
          onSearch={debounceFetcher}
          style={{
            width: '100%',
            marginRight: "-1px",
          }}
          notFoundContent={loading ? <Spin size="small" /> : null}
      />
      <Popover
        zIndex="20000"
        trigger="hover"
        content={content}
        placement="left"
        title="Search Filter"
        open={popoverOpen}
        onOpenChange={onOpenChange}
      >
        <Button>
          <Icon
            type="filter"
            className="fa-sharp"
            style={{
                color: "#666",
                fontSize: "12px" 
            }}
          />
        </Button>
      </Popover>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  .ant-select-selector {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .ant-btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`

const Content = styled.div`
  margin-top: 10px;
  justify-content: center;
`

const mapStateToProps = state => {
  const { id: workingFolder } = state.workingFolder;
  return { workingFolder };
};

export default connect(mapStateToProps)(UserPicker);